import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'lp2-gamification-activity-points',
  templateUrl: './gamification-activity-points.component.html',
  styleUrls: ['./gamification-activity-points.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GamificationActivityPointsComponent {
  @Input() points: number;
}



// WEBPACK FOOTER //
// ./ts/app/shared/gamification-activity-points/gamification-activity-points.component.ts